import utils from "@/api/utils"
import auth from "@/api/auth"
import user from "@/api/user"
import school from "@/api/school"
import organization from "@/api/organization"
import consumer from "@/api/consumer"
import coordinator from "@/api/coordinator"
import instructor from "@/api/instructor"
import vendor from "@/api/vendor"
import supervisor from "@/api/supervisor"
import config from "@/api/config"
import program from "@/api/program"
import consumerProgram from "@/api/consumerProgram"
import vendorProgram from "@/api/vendorProgram"
import programGroup from "@/api/programGroup"
import vendorProgramGroup from "@/api/vendorProgramGroup"
import consumerProgramGroup from "@/api/consumerProgramGroup"
import instructorProgramGroup from "@/api/instructorProgramGroup"
import event from "@/api/event"
import consumerEvent from "@/api/consumerEvent"
import instructorEvent from "@/api/instructorEvent"
import eventFeedPost from "@/api/eventFeedPost"
import vendorEvent from "@/api/vendorEvent"
import termsOfUse from "@/api/termsOfUse"

export default {
  utils,
  auth,
  user,
  school,
  organization,
  consumer,
  coordinator,
  instructor,
  vendor,
  supervisor,
  config,
  program,
  vendorProgram,
  consumerProgram,
  programGroup,
  vendorProgramGroup,
  consumerProgramGroup,
  instructorProgramGroup,
  event,
  consumerEvent,
  instructorEvent,
  eventFeedPost,
  vendorEvent,
  termsOfUse,
}
